import { useState } from 'react';
import { FaLeaf } from 'react-icons/fa';
import SEO from '../SEO'; // Import the SEO component

function ContactUs() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, email, subject, message } = formData;
        const whatsappMessage = `Name: ${name}\nEmail: ${email}\nSubject: ${subject}\nMessage: ${message}`;
        const whatsappUrl = `https://wa.me/+94779291829?text=${encodeURIComponent(whatsappMessage)}`;
        window.open(whatsappUrl, '_blank');
    };

    // SEO Structured Data
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "Contact Galle Ceylon Spices International",
        "description": "Get in touch with Galle Ceylon Spices International for inquiries about premium Ceylon cinnamon and spices. Reach us via WhatsApp, email, or visit our office in Elpitiya, Sri Lanka.",
        "url": "https://www.galleceylonspices.com/contact",
        "publisher": {
            "@type": "Organization",
            "name": "Galle Ceylon Spices International (Pvt) Ltd",
            "logo": {
                "@type": "ImageObject",
                "url": "%PUBLIC_URL%/logo.png"
            },
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "448/2, Nawadagala, near the school",
                "addressLocality": "Elpitiya",
                "postalCode": "80000",
                "addressCountry": "Sri Lanka"
            },
            "contactPoint": [
                {
                    "@type": "ContactPoint",
                    "telephone": "+94-77-929-1829",
                    "contactType": "Customer Service",
                    "contactOption": "WhatsApp",
                    "areaServed": "Worldwide",
                    "availableLanguage": "English"
                },
                {
                    "@type": "ContactPoint",
                    "email": "galleceylonspices@gmail.com",
                    "contactType": "Customer Service",
                    "areaServed": "Worldwide",
                    "availableLanguage": "English"
                }
            ],
            "sameAs": [
                "https://www.galleceylonspices.com"
            ]
        }
    };

    return (
        <div className="container my-4 py-4">
            <SEO
                title="Contact Us - Galle Ceylon Spices International"
                description="Get in touch with Galle Ceylon Spices International for inquiries about premium Ceylon cinnamon and spices. Reach us via WhatsApp, email, or visit our office in Elpitiya, Sri Lanka."
                keywords="contact Galle Ceylon Spices, Ceylon cinnamon inquiries, Sri Lankan spices contact, Elpitiya spice supplier, WhatsApp spice inquiry, galleceylonspices email"
                canonicalUrl="https://www.galleceylonspices.com/contact"
                ogImage="%PUBLIC_URL%/logo.png"
                structuredData={structuredData}
            />
            {/* Top Section */}
            <div
                className="text-center p-4 rounded-3 shadow-lg animate__animated animate__fadeIn"
                style={{
                    animationDuration: '1s',
                    backgroundColor: 'rgba(193, 154, 107, 0.1)',
                    marginBottom: '2rem'
                }}
            >
                <h1
                    className="mb-3 position-relative"
                    style={{
                        color: '#355E3B',
                        fontFamily: 'Georgia',
                        fontSize: 'clamp(2rem, 5vw, 3rem)',
                        lineHeight: '1.2',
                    }}
                >
                    Contact Us
                    <span
                        style={{
                            position: 'absolute',
                            bottom: '-8px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '80px',
                            height: '2px',
                            backgroundColor: '#C19A6B',
                            borderRadius: '2px',
                        }}
                    />
                </h1>
                <FaLeaf size={80} style={{ color: '#355E3B' }} className="mb-3" />
            </div>

            {/* Contact Information Section */}
            <div className="row justify-content-center g-4">
                <div className="col-12 col-md-4 mb-3 animate__animated animate__fadeInUp" style={{ animationDelay: '0.2s', animationDuration: '0.8s' }}>
                    <div
                        className="card h-100 p-3 text-center"
                        style={{
                            border: '1px solid rgba(193, 154, 107, 0.3)',
                            borderRadius: '8px',
                            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 6px 15px rgba(193, 154, 107, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                        }}
                    >
                        <h5 style={{ color: '#355E3B', fontSize: 'clamp(1.2rem, 3vw, 1.5rem)', fontFamily: 'Georgia', fontWeight: 'bold' }}>
                            Corporate Office
                        </h5>
                        <p style={{ color: '#C19A6B', fontFamily: 'Georgia', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', lineHeight: '1.5' }}>
                            448/2,<br />
                            near the school, Nawadagala,<br />
                            Elpitiya, Sri Lanka 80000
                        </p>
                    </div>
                </div>
                <div className="col-12 col-md-4 mb-3 animate__animated animate__fadeInUp" style={{ animationDelay: '0.4s', animationDuration: '0.8s' }}>
                    <div
                        className="card h-100 p-3 text-center"
                        style={{
                            border: '1px solid rgba(193, 154, 107, 0.3)',
                            borderRadius: '8px',
                            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 6px 15px rgba(193, 154, 107, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                        }}
                    >
                        <h5 style={{ color: '#355E3B', fontSize: 'clamp(1.2rem, 3vw, 1.5rem)', fontFamily: 'Georgia', fontWeight: 'bold' }}>
                            Hotline
                        </h5>
                        <p style={{ color: '#C19A6B', fontFamily: 'Georgia', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', lineHeight: '1.5' }}>
                            +94 77 929 1829
                        </p>
                    </div>
                </div>
                <div className="col-12 col-md-4 mb-3 animate__animated animate__fadeInUp" style={{ animationDelay: '0.6s', animationDuration: '0.8s' }}>
                    <div
                        className="card h-100 p-3 text-center"
                        style={{
                            border: '1px solid rgba(193, 154, 107, 0.3)',
                            borderRadius: '8px',
                            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 6px 15px rgba(193, 154, 107, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                        }}
                    >
                        <h5 style={{ color: '#355E3B', fontSize: 'clamp(1.2rem, 3vw, 1.5rem)', fontFamily: 'Georgia', fontWeight: 'bold' }}>
                            Email
                        </h5>
                        <p style={{ color: '#C19A6B', fontFamily: 'Georgia', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', lineHeight: '1.5' }}>
                            galleceylonspices@gmail.com
                        </p>
                        <h5 style={{ color: '#355E3B', fontSize: 'clamp(1.2rem, 3vw, 1.5rem)', fontFamily: 'Georgia', fontWeight: 'bold', marginTop: '1rem' }}>
                            Website
                        </h5>
                        <a
                            href="https://www.galleceylonspices.com"
                            style={{
                                color: '#C19A6B',
                                fontFamily: 'Georgia',
                                fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                textDecoration: 'none',
                                transition: 'color 0.3s ease-in-out',
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.color = '#A67B4D')}
                            onMouseLeave={(e) => (e.currentTarget.style.color = '#C19A6B')}
                        >
                            www.galleceylonspices.com
                        </a>
                    </div>
                </div>
            </div>

            {/* Contact Form and Map Section */}
            <div className="row g-4 mt-5">
                <div className="col-12 col-md-6 mb-3 animate__animated animate__fadeInUp" style={{ animationDelay: '0.2s', animationDuration: '0.8s' }}>
                    <div className="card p-3 shadow-sm" style={{ borderRadius: '8px', border: '1px solid rgba(193, 154, 107, 0.3)' }}>
                        <p
                            style={{
                                color: '#355E3B',
                                fontFamily: 'Georgia',
                                fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                lineHeight: '1.6',
                                marginBottom: '1.5rem',
                            }}
                        >
                            Our team is eager to assist with your inquiries about our premium Ceylon spices. Complete the form, and we’ll respond promptly via WhatsApp.
                        </p>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your full name"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        border: '1px solid rgba(193, 154, 107, 0.3)',
                                        fontFamily: 'Georgia',
                                        fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                                        padding: '8px',
                                        transition: 'border-color 0.3s ease-in-out',
                                    }}
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    onFocus={(e) => (e.target.style.borderColor = '#C19A6B')}
                                    onBlur={(e) => (e.target.style.borderColor = 'rgba(193, 154, 107, 0.3)')}
                                    required
                                    aria-label="Full name"
                                />
                            </div>
                            <div className="mb-3">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter your email address"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        border: '1px solid rgba(193, 154, 107, 0.3)',
                                        fontFamily: 'Georgia',
                                        fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                                        padding: '8px',
                                        transition: 'border-color 0.3s ease-in-out',
                                    }}
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    onFocus={(e) => (e.target.style.borderColor = '#C19A6B')}
                                    onBlur={(e) => (e.target.style.borderColor = 'rgba(193, 154, 107, 0.3)')}
                                    required
                                    aria-label="Email address"
                                />
                            </div>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter the subject of your inquiry"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        border: '1px solid rgba(193, 154, 107, 0.3)',
                                        fontFamily: 'Georgia',
                                        fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                                        padding: '8px',
                                        transition: 'border-color 0.3s ease-in-out',
                                    }}
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    onFocus={(e) => (e.target.style.borderColor = '#C19A6B')}
                                    onBlur={(e) => (e.target.style.borderColor = 'rgba(193, 154, 107, 0.3)')}
                                    required
                                    aria-label="Subject"
                                />
                            </div>
                            <div className="mb-4">
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter your message or inquiry"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        border: '1px solid rgba(193, 154, 107, 0.3)',
                                        fontFamily: 'Georgia',
                                        fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                                        padding: '8px',
                                        transition: 'border-color 0.3s ease-in-out',
                                    }}
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    onFocus={(e) => (e.target.style.borderColor = '#C19A6B')}
                                    onBlur={(e) => (e.target.style.borderColor = 'rgba(193, 154, 107, 0.3)')}
                                    required
                                    aria-label="Message"
                                ></textarea>
                            </div>
                            <button
                                type="submit"
                                className="btn w-100"
                                style={{
                                    backgroundColor: '#C19A6B',
                                    color: '#FFFFFF',
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                                    padding: '10px',
                                    transition: 'all 0.3s ease-in-out',
                                    boxShadow: '0 3px 8px rgba(0, 0, 0, 0.15)',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#A67B4D';
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.25)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#C19A6B';
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 3px 8px rgba(0, 0, 0, 0.15)';
                                }}
                                aria-label="Send message via WhatsApp"
                            >
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
                <div className="col-12 col-md-6 mb-3 animate__animated animate__fadeInUp" style={{ animationDelay: '0.4s', animationDuration: '0.8s' }}>
                    <div
                        className="card shadow-sm"
                        style={{
                            borderRadius: '8px',
                            border: '1px solid rgba(193, 154, 107, 0.3)',
                            overflow: 'hidden',
                            height: '100%',
                        }}
                    >
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4192.832539201861!2d80.14413119999999!3d6.311624999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xaa7db4afde0c72a9%3A0xb3482e65c4fb5ee!2sGalle%20Ceylon%20Spices%20International%20(Pvt)%20Ltd!5e1!3m2!1sen!2slk!4v1746879976785!5m2!1sen!2slk"
                            width="100%"
                            height="100%"
                            style={{ border: 0, minHeight: '300px' }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Galle Ceylon Spices International Location"
                            aria-label="Map showing the location of Galle Ceylon Spices International in Elpitiya, Sri Lanka"
                        ></iframe>
                    </div>
                </div>
            </div>

            {/* Inline CSS for responsiveness */}
            <style>
                {`
                    @media (max-width: 576px) {
                        .card {
                            margin-bottom: 1rem;
                        }
                        .p-4 {
                            padding: 1rem !important;
                        }
                        .p-3 {
                            padding: 0.75rem !important;
                        }
                        .form-control {
                            font-size: 0.9rem !important;
                            padding: 6px !important;
                        }
                        textarea.form-control {
                            min-height: 100px !important;
                        }
                        .btn {
                            font-size: 1rem !important;
                            padding: 8px !important;
                        }
                        iframe {
                            min-height: 250px !important;
                        }
                        .row.g-4 {
                            --bs-gutter-x: 0.5rem;
                        }
                    }
                    @media (max-width: 576px) and (orientation: landscape) {
                        .card {
                            margin-bottom: 0.5rem;
                        }
                        iframe {
                            min-height: 200px !important;
                        }
                        textarea.form-control {
                            min-height: 80px !important;
                        }
                        .p-3 {
                            padding: 0.5rem !important;
                        }
                    }
                    @media (min-width: 577px) and (max-width: 768px) {
                        .card {
                            margin-bottom: 1.5rem;
                        }
                        .p-4 {
                            padding: 1.5rem !important;
                        }
                        .p-3 {
                            padding: 1rem !important;
                        }
                        iframe {
                            min-height: 350px !important;
                        }
                        .row.g-4 {
                            --bs-gutter-x: 1rem;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .card {
                            margin-bottom: 2rem;
                        }
                        .p-4 {
                            padding: 2rem !important;
                        }
                        iframe {
                            min-height: 400px !important;
                        }
                        .row.g-4 {
                            --bs-gutter-x: 1.5rem;
                        }
                    }
                    @media (min-width: 1025px) {
                        .card {
                            margin-bottom: 2.5rem;
                        }
                        .p-4 {
                            padding: 2.5rem !important;
                        }
                        iframe {
                            min-height: 450px !important;
                        }
                        .row.g-4 {
                            --bs-gutter-x: 2rem;
                        }
                    }
                `}
            </style>
        </div>
    );
}

export default ContactUs;